import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error Boundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, color: "white", background: "#0a0a0f", minHeight: "100vh" }}>
          <h1 style={{ color: "#7C5CFC", marginBottom: 16 }}>Something went wrong</h1>
          <p style={{ marginBottom: 8 }}>Error: {this.state.error?.message}</p>
          <pre style={{ background: "#1a1a2e", padding: 16, borderRadius: 8, overflow: "auto", fontSize: 12 }}>
            {this.state.error?.stack}
          </pre>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
            style={{ marginTop: 16, padding: "8px 24px", background: "#7C5CFC", color: "white", border: "none", borderRadius: 20, cursor: "pointer" }}
          >
            Go Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
